/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    stroke="currentColor"
    d="M7.8576 15.6901a.32.32 0 0 1 .4523.4526l-3.9892 3.9891.3463.3463-.3463-.3463a.3176.3176 0 0 1-.2262.0936.3172.3172 0 0 1-.2263-.0938.3198.3198 0 0 1 .0002-.4524l3.9892-3.9891Zm8.2848-7.3802-.0001.0002a.317.317 0 0 1-.2261.0936.317.317 0 0 1-.226-.0936l-.0002-.0002a.3195.3195 0 0 1 0-.4522l.0001-.0001 3.9892-3.9892.0001-.0002a.3197.3197 0 0 1 .4521 0l.0002.0002a.3197.3197 0 0 1 0 .4522l-.0001.0001-3.9892 3.9892Zm-8.2847.0002-.0001-.0002-3.9892-3.9892h-.0001a.3196.3196 0 0 1 0-.4523l.0002-.0002a.3196.3196 0 0 1 .452 0l.0002.0002 3.9892 3.9892H8.31a.3196.3196 0 0 1 0 .4523l-.0002.0002a.3171.3171 0 0 1-.226.0936.317.317 0 0 1-.226-.0936Zm11.8216 11.8217-.3264.3263.3264-.3263-3.9893-3.9891a.32.32 0 0 1 .4524-.4526l.3536-.3536-.3536.3536 3.9892 3.9891a.3199.3199 0 0 1-.2261.5462.3175.3175 0 0 1-.2262-.0936ZM12.3199 6.4615a.32.32 0 1 1-.6398 0V.8199a.32.32 0 1 1 .6398 0v5.6416ZM6.4615 11.68a.32.32 0 1 1 0 .6398H.8199a.32.32 0 1 1 0-.6398h5.6416Zm11.077.6398a.3199.3199 0 1 1 0-.6398H23.18a.32.32 0 1 1 0 .6398h-5.6415ZM12.3199 23.18a.32.32 0 1 1-.6398 0v-5.6415a.3199.3199 0 1 1 .6398 0V23.18Z"
  />,
  'Loader'
);
